import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { mergeMap } from 'rxjs/operators';
import { PricingRuleAction } from '../pricingRule.action';
import { PricingRuleTranslator } from '../pricingRule.translator';

type IDependencies = IClientApiDependencySegment;

export const updatePricingRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingRuleAction.update.started),
  mergeMap((params) => {
    const rules = params.map(PricingRuleTranslator.toApi);
    return dependencies.api.updatePricingRules({ rules }).pipe(
      mergeMap(() => {
        return [
          PricingRuleAction.update.done({ params, result: [] }),
        ];
      }),
      catchApiError((error) => {
        return [
          PricingRuleAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
